/** ListBox columns wider than this use large image layout (banner / preview icons). */
export const LISTBOX_WIDE_COLUMN_MIN_WIDTH_PX = 80

export function isWideListboxColumnWidth(widthPx: number | null | undefined): boolean {
  return widthPx != null && widthPx >= LISTBOX_WIDE_COLUMN_MIN_WIDTH_PX
}

export function isFalsyListboxCatalogCode(code: unknown): boolean {
  if (code === null || code === undefined || code === '') return true
  if (typeof code === 'boolean') return !code
  if (typeof code === 'number') return Number.isNaN(code)
  const normalized = String(code).trim().toLowerCase()
  return normalized === 'false' || normalized === 'no' || normalized === 'n'
}

/** Visible label in a ListBox table cell. Falsy catalog codes render empty (Swing icon-or-blank). */
export function resolveVisibleListboxCellText(
  code: unknown,
  displayText: string,
  hasIcon = false,
): string {
  if (hasIcon) return ''
  if (isFalsyListboxCatalogCode(code)) return ''
  return displayText
}
